import { render, staticRenderFns } from "./PaymentSuccessStoreFaq.vue?vue&type=template&id=595658a2"
import script from "./PaymentSuccessStoreFaq.vue?vue&type=script&lang=js"
export * from "./PaymentSuccessStoreFaq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports